// extracted by mini-css-extract-plugin
export var container = "styles-module--container--d9749";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--bc863";